// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 69 ? "core_info" : chunkId) + "." + {"69":"b6708e5d","831":"3497722f"}[chunkId] + ".js";
};